import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },
  buttons: {
    width: '100%'
  },
  itemsMenu: {
    zIndex: 2000,
    width: '100%'
  }
}))

export {
  useStyles
}
